import useMediaQuery from "./useMediaQuery";

/**
 * *Keeping desktop is causing UI look ugly at screen size between tablet an Desktop
 * *This need to be changed later to desktop once the sidebar breakpoint is changed to desktop
 */
const useInDesktop = () => useMediaQuery("tablet", "up");

export default useInDesktop;
